import { ElementApi, getPluginType } from 'platejs'
import type { EditorAboveOptions, NodeEntry, TElement, TNode } from 'platejs'

import type { SerializedNode } from '~publish/legacy/editor/BufferEditor/types'
import type {
  BufferEditor,
  BufferValue,
  PlainText,
} from '~publish/legacy/editor/BufferEditor/types.plate'

export const EMOJI_SEARCH_ELEMENT_TYPE = 'emoji-search'
export const EMOJI_SEARCH_ELEMENT_TRIGGER = ':'

export interface EmojiSearchElement extends TElement {
  trigger: string
  children: [PlainText]
}

export const EmojiSearchElement = {
  type: EMOJI_SEARCH_ELEMENT_TYPE,
  trigger: EMOJI_SEARCH_ELEMENT_TRIGGER,
  is(node: TNode | undefined): node is EmojiSearchElement {
    return (
      !!node &&
      ElementApi.isElement(node) &&
      node.type === EmojiSearchElement.type
    )
  },
  // Children stay empty — the typed search text lives in the combobox's own
  // input state (see EmojiSearchElementUI), not in the Slate document.
  new(trigger: string): EmojiSearchElement {
    return {
      type: EmojiSearchElement.type,
      trigger,
      children: [{ text: '' }],
    }
  },
  serialize(node: TNode): SerializedNode {
    return { text: `${node.trigger}` }
  },
  findEmojiSearch(
    editor: BufferEditor,
    options?: Omit<EditorAboveOptions<BufferValue>, 'match'>,
  ): NodeEntry<EmojiSearchElement> | undefined {
    return editor.api.above<EmojiSearchElement>({
      ...options,
      match: {
        type: getPluginType(editor, EmojiSearchElement.type),
      },
    })
  },
  isSelectionInEmojiSearch(editor: BufferEditor): boolean {
    return EmojiSearchElement.findEmojiSearch(editor) !== undefined
  },
}
